// CLASSES
import AppConfig from "@classes/AppConfig";
import Validator from "@classes/Validator";

export default function (props, state) {
	if (AppConfig.get("developmentOptions").ignoreFullfillment === true) {
		return true;
	}

	const {fields, validFields, company} = state;

	for (const name in validFields) {
		if (validFields[name] === false) {
			return false;
		}
	}

	if (company || !fields.checkbox_insured_same.checked) {
		if (!Validator.validateSsn(fields.futur_insured_ssn)) {
			return false;
		}

		if (!Validator.validateEmail(fields.futur_insured_email)) {
			return false;
		}

		// Om man angett att man har annat medborgarskap än svenskt måste fältet fyllas i
		if (fields.checkbox_additional_citizenship.checked && fields.futur_insured_citizenship_2.length === 0) {
			return false;
		}
	}

	return true;
}


// WEBPACK FOOTER //
// ./src/routes/Cob/views/Futur/Insured/Insured.fulfillment.js